/**
 Les libellés des périodes historiques ayant servis à la réindexation du fonds en sept 2018 sont erronés suite à une mauvaise communication de BnF.
Afin d'éviter une réindexation du fonds, il a été décidé d'hardcoder les libellés en front dans l'app RetroNews.
key : valeur indexées en 2018
label : label affichée dans l'app
 */
module.exports = [
    {
        key: "Grand siècle de Louis XIV",
        label: "Grand siècle (-1715)"
    },
    {
        key: "Siècle des Lumières",
        label: "Siècle des Lumières (1715-1789)"
    },
    {
        key: "La Révolution (1789 - 1799)",
        label: "Révolution française (1789-1799)"
    },
    {
        key: "Consulat et Empire (1799-1814)",
        label: "Consulat et Empire (1799-1814)"
    },
    {
        key: "La Restauration (1814-1830)",
        label: "Restauration (1814-1830)"
    },
    {
        key: "Monarchie de Juillet (1830-1848)",
        label: "Monarchie de Juillet (1830-1848)"
    },
    {
        key: "La IIe République (1848-1852)",
        label: "IIᵉ République (1848-1852)"
    },
    {
        key: "Le Second Empire (1852-1870)",
        label: "Second Empire (1852-1870)"
    },
    {
        key: "La Commune",
        label: "Commune (1870-1871)"
    },
    {
        key: "Les Débuts de la IIIème République (1871-1898)",
        label: "Débuts de la IIIᵉ Rép. (1871-1898)"
    },
    {
        key: "La République radicale (1898-1914)",
        label: "République radicale (1898-1914)"
    },
    {
        key: "Première guerre mondiale (1914-1918)",
        label: "Première guerre mondiale (1914-1918)"
    },
    {
        key: "Entre deux guerres",
        label: "Entre-deux-guerres (1918-1939)"
    },
    {
        key: "Seconde guerre mondiale (1939-1945)",
        label: "Seconde guerre mondiale (1939-1945)"
    },
    {
        key: "GPRF (1944-1946)",
        label: "GPRF (1944-1946)"
    },
    {
        key: "IVè république",
        label: "IVᵉ République (1946-1958)"
    },
    {
        key: "Vè république",
        label: "Vᵉ République (1958-)"
    }
];